import { createSlice } from '@reduxjs/toolkit';

type Variant = {
  id: number;
  quantity: number;
  addon_level_ids: number[]; // 👈 ADD THIS
  addons: Record<
    number,
    {
      addonId: number;
      name: string;
      amount: number;
    }
  >;
  unitPrice: number;
  addonsTotal: number;
};

type TCartVariantState = {
  variants: Record<string, Variant[]>;
};

const initialState: TCartVariantState = {
  variants: {},
};

export const cartVariantSlice = createSlice({
  name: 'cart-variant',
  initialState,
  reducers: {
    setVariants: (state: TCartVariantState, action) => {
      // state.value += 1;
      state = { ...state.variants, ...action.payload };
    },
  },
});

export const { setVariants } = cartVariantSlice.actions;
export default cartVariantSlice.reducer;
